import { render, staticRenderFns } from "./icon_select.vue?vue&type=template&id=0bbd5052&"
import script from "./icon_select.vue?vue&type=script&lang=js&"
export * from "./icon_select.vue?vue&type=script&lang=js&"
import style0 from "./icon_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports